import { NavLink } from 'react-router-dom'
import { Bike, ChefHat, LayoutGrid, LogOut, MessageCircle, Printer, Receipt, Store, TrendingUp, UsersRound, Volume2, VolumeX, WifiOff } from 'lucide-react'
import { Badge, Button, Icone, LogoMark, cn } from '@du/ui'
import { useSessao } from '../lib/sessao.js'

const MENU = [
  { para: '/', rotulo: 'Pedidos', icone: LayoutGrid, fim: true },
  { para: '/historico', rotulo: 'Histórico', icone: Receipt },
  { para: '/vendas', rotulo: 'Vendas', icone: TrendingUp },
  { para: '/cardapio', rotulo: 'Cardápio', icone: ChefHat },
  { para: '/clientes', rotulo: 'Clientes', icone: UsersRound },
  { para: '/motoboys', rotulo: 'Motoboys', icone: Bike },
  { para: '/loja', rotulo: 'Loja', icone: Store },
  { para: '/impressoras', rotulo: 'Impressão', icone: Printer },
  { para: '/whatsapp', rotulo: 'WhatsApp', icone: MessageCircle },
]

export function Layout({
  conectado,
  som,
  children,
}: {
  conectado: boolean
  som: { ligado: boolean; ativar: () => void }
  children: React.ReactNode
}) {
  const { usuario, sair } = useSessao()

  return (
    <div className="app">
      <header className="app__topo">
        <LogoMark largura={132} />

        <nav className="app__menu">
          {MENU.map((m) => (
            <NavLink
              key={m.para}
              to={m.para}
              {...(m.fim ? { end: true } : {})}
              className={({ isActive }) => cn('app__link', isActive && 'app__link--ativo')}
            >
              <Icone de={m.icone} tamanho={20} />
              <span>{m.rotulo}</span>
            </NavLink>
          ))}
        </nav>

        <div className="app__direita">
          {/* Estado da conexão sempre visível: sem tempo real, o Kanban mente
              em silêncio, e quem está na cozinha precisa saber disso. */}
          {/* Som mudo precisa APARECER. Antes falhava em silêncio: a cozinha
              confiava num bipe que nunca ia tocar, e ninguém descobria até o
              pedido esfriar no Kanban. */}
          {!som.ligado ? (
            <button type="button" className="app__som-off" onClick={som.ativar}>
              <Icone de={VolumeX} tamanho={16} />
              Som desligado — clique
            </button>
          ) : (
            <span className="app__som-on" title="Som de pedido novo ligado">
              <Icone de={Volume2} tamanho={16} />
            </span>
          )}
          {conectado ? (
            <Badge tom="sucesso">Ao vivo</Badge>
          ) : (
            <span className="app__offline" title="Sem tempo real — reconectando">
              <Icone de={WifiOff} tamanho={16} />
              Reconectando
            </span>
          )}
          <span className="app__usuario">
            {usuario?.nome}
            <Badge tom="neutro">{usuario?.papel}</Badge>
          </span>
          <Button variante="ghost" tamanho="sm" icone={LogOut} onClick={() => void sair()}>
            Sair
          </Button>
        </div>
      </header>

      <main className="app__corpo">{children}</main>
    </div>
  )
}
